<template>
<div class="container main">
  <div class="row">
    <div class="offset-10 col-2 head-buttons-block">
      <router-link :to="{ name: 'auth'}" class="login-btn">
        <div class="enter-logo"></div><span>Войти</span>
      </router-link>
    </div>
    <div class="col-md-12">
      <div class="logo">
        <img src="/static/img/logo.png">
          </div>
      </div>
      <div class="col-md-12">
        <div class="loader" v-if="wait_answer">
          <loader-component />
        </div>
      </div>
      <div class="offset-md-3 col-md-6">
      <msg-component :type_msg="msg_code.type" :text="msg_code.text"></msg-component>
      </div>
    </div>
  </div>
</template>

<script>
import msg from './elements/msg.vue'
import axios from 'axios'
import config from '@/config.js'
import loader from './elements/loader.vue'

export default {
  created() {
    ckeckRecoveryCode(this)
  },
  data() {
    return {
      msg_code: {
        type: 'hidden',
        text: ''
      },
      email: '',
      wait_answer: true
    }
  },
  components: {
    'msg-component': msg,
    'loader-component': loader
  }
}

function ckeckRecoveryCode(vue_obj) {
  var post_data = new FormData()
  post_data.set('restore_code', vue_obj.$route.params.recovert_code)
  axios({
      method: 'POST',
      url: config.API_HOST + '/admin-user/restore-password',
      data: post_data
    })
    .then(function (response) {
      if (!!response.data.text) {
        vue_obj.msg_code.type = 'success'
        vue_obj.msg_code.text = response.data.text
      }
      vue_obj.wait_answer = false
    })
    .catch(function (error) {
      console.log(error.response.data)
      if (!!error.response.data.exception) {
        vue_obj.msg_code.type = 'alert'
        vue_obj.msg_code.text = error.response.data.exception
      }
      vue_obj.wait_answer = false
    })
}
</script>



// WEBPACK FOOTER //
// src/components/check_recovery_password.vue